// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contract-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  font-family: "Barlow", sans-serif;
}
@media (max-width: 1024px) {
  .contract-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 0rem;
    margin-top: 95px;
  }
}
.contract-container .header {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 45px 0px;
}
.contract-container .header h6 {
  margin: 0px;
  width: 80%;
  font-size: 32px;
  padding-left: 2rem;
}
@media (max-width: 1024px) {
  .contract-container .header h6 {
    font-size: 18px;
    text-align: center;
  }
}
.contract-container .header h5 {
  font-size: 24px;
  margin-top: 10px;
  margin-bottom: 0px;
  color: #706f6f;
  padding-left: 2rem;
}
@media (max-width: 1024px) {
  .contract-container .header h5 {
    font-size: 16px;
    text-align: center;
  }
}
.contract-container .header h6 {
  margin: 0rem;
}

@media (min-width: 1025px) {
  .header {
    flex-direction: column !important;
    justify-content: center !important;
    align-items: start !important;
  }
}
.form-fields {
  background-color: #FBFBFB;
  display: flex;
  justify-content: start;
  align-items: center;
  min-height: 32vh;
  flex-direction: column;
}
@media (max-width: 1024px) {
  .form-fields {
    background-color: #FBFBFB;
  }
}
.form-fields .fields {
  padding-top: 32px !important;
  width: 80%;
}

.form-group-row {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  column-gap: 3rem;
}
@media (max-width: 1024px) {
  .form-group-row .mat-mdc-form-field {
    width: 100%;
  }
}
.form-group-row .first-input {
  width: 100%;
}
.form-group-row .bank-form-field {
  width: 30%;
}
.form-group-row p {
  margin-top: 0px;
  font-size: 1.1rem;
}
@media (max-width: 1024px) {
  .form-group-row {
    flex-direction: column;
  }
}

.form-group {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  column-gap: 3rem;
}
.form-group .first-input {
  width: 100%;
}
.form-group .date-input {
  width: 30%;
}
.form-group .bank-form-field {
  width: 30%;
}
.form-group p {
  margin-top: 0px;
  font-size: 1.1rem;
}

::ng-deep.mat-mdc-text-field-wrapper {
  background: white;
}

.date-select-modal-filter {
  width: 45%;
  display: flex;
  border: 1px solid rgb(189, 188, 188);
  border-radius: 5px;
  align-items: center;
  justify-content: center;
  height: 70px;
  background: white;
}
@media (max-width: 1024px) {
  .date-select-modal-filter {
    width: 100%;
    margin-bottom: 24px;
  }
}
.date-select-modal-filter .mat-mdc-form-field {
  margin-bottom: -1rem;
  width: 60%;
  height: 50px;
}
.date-select-modal-filter .mat-mdc-form-field:nth-of-type(2) {
  height: 50px;
  margin-right: 10px !important;
}
.date-select-modal-filter .select-year {
  margin-bottom: -1rem;
  width: 40%;
}
@media (max-width: 1024px) {
  .date-select-modal-filter .select-year {
    width: 35%;
  }
}

@media (max-width: 1240px) {
  .capexGroup {
    margin-bottom: 16px;
    flex-wrap: wrap;
  }
  .capexGroup .onlyFieldset {
    width: 100% !important;
  }
  .form-group .date-select-modal-filter {
    width: 46%;
    margin-bottom: 8px;
  }
  .form-group .mat-mdc-form-field {
    width: 100%;
  }
}
.section-periodo {
  display: flex;
  width: 45%;
  justify-content: space-between;
}
@media (max-width: 1024px) {
  .section-periodo {
    width: 100%;
    flex-direction: column;
    align-items: center;
  }
}
.section-periodo .date-select-modal-filter {
  width: 35%;
}
@media (max-width: 1024px) {
  .section-periodo .date-select-modal-filter {
    width: 100% !important;
  }
}
.section-periodo .date-select-modal-filter .select-year {
  margin-bottom: -1rem;
  width: 75%;
}
@media (max-width: 1024px) {
  .section-periodo .date-select-modal-filter .select-year {
    width: 35% !important;
  }
}
.section-periodo .periodo {
  display: flex;
  flex-direction: row;
  padding-bottom: 10px;
  border-bottom: 1px solid #efefef;
  align-items: center;
}

.button-save {
  width: 100%;
  display: flex;
  justify-content: center;
}
.button-save button {
  display: flex;
  justify-content: center;
  color: #AE0F0A;
  font-size: 16px;
  width: 25%;
  min-width: 160px;
  align-items: end;
  font-weight: 700;
}
.button-save button img {
  width: 20px;
  padding-right: 8px;
}

::ng-deep .mat-mdc-icon-button {
  --mat-mdc-button-persistent-ripple-color: transparent;
}

.table-default {
  padding-left: 2rem;
  padding-right: 2rem;
  margin-top: 24px;
}

.buttons {
  display: flex;
  justify-content: center;
  margin-top: 24px;
  margin-bottom: 24px;
}

.row {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 16px 16px;
}

.w-100 {
  width: 100%;
}

.info-icon-suffix {
  width: 14px;
  height: 14px;
  margin-right: 10px;
  cursor: pointer;
}

::ng-deep .mat-primary .mat-pseudo-checkbox-checked.mat-pseudo-checkbox-full, .mat-primary .mat-pseudo-checkbox-indeterminate.mat-pseudo-checkbox-full {
  background-color: rgb(174, 15, 10) !important;
}

.group {
  border: 1px solid #ccc;
  padding: 16px;
  margin-bottom: 16px;
  border-radius: 8px;
}

.group legend {
  font-size: 1em;
  font-weight: bold;
  margin-bottom: 8px;
  text-align: center;
  color: rgb(102, 102, 102);
}

.form-group-row-fieldset {
  width: 100%;
  display: flex;
  align-items: flex-start;
  column-gap: 3rem;
  justify-content: space-between;
}

.onlyFieldset {
  width: 50% !important;
}
.onlyFieldset fieldset {
  width: 100%;
}
@media (max-width: 1024px) {
  .onlyFieldset {
    width: 100% !important;
  }
}

@media (max-width: 1321px) {
  .form-group-row-fieldset {
    flex-wrap: wrap;
  }
}
.prazo-analise-fields {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: center;
  justify-content: flex-start;
}

.prazo-dias-field-sm {
  flex: 1;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/components/contracts/edit-contract/ampliacao/form-ampliacao/form-ampliacao.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,iCAAA;AACJ;AAAI;EALJ;IAMM,WAAA;IACA,aAAA;IACA,sBAAA;IACA,aAAA;IACA,gBAAA;EAGJ;AACF;AADI;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAGN;AAEM;EACE,WAAA;EACA,UAAA;EACA,eAAA;EACA,kBAAA;AAAR;AACQ;EALF;IAMI,eAAA;IACA,kBAAA;EAER;AACF;AAAM;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;AAER;AADQ;EANF;IAOI,eAAA;IACA,kBAAA;EAIR;AACF;AADM;EACE,YAAA;AAGR;;AACA;EACI;IACE,iCAAA;IACA,kCAAA;IACA,6BAAA;EAEJ;AACF;AAEE;EACE,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;AAAJ;AACI;EAPF;IAQM,yBAAA;EAEN;AACF;AAAI;EACI,4BAAA;EACA,UAAA;AAER;;AACA;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;AAEJ;AAGQ;EAFJ;IAGM,WAAA;EAAR;AACF;AAGI;EACI,WAAA;AADR;AAII;EACI,UAAA;AAFR;AAKI;EACI,eAAA;EACA,iBAAA;AAHR;AAKI;EA3BJ;IA4BM,sBAAA;EAFJ;AACF;;AAKA;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;AAFJ;AAQI;EACI,WAAA;AANR;AASI;EACI,UAAA;AAPR;AAUI;EACI,UAAA;AARR;AAWI;EACI,eAAA;EACA,iBAAA;AATR;;AAYA;EACE,iBAAA;AATF;;AAYA;EACI,UAAA;EACA,aAAA;EACA,oCAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;AATJ;AAUI;EATJ;IAUQ,WAAA;IACA,mBAAA;EAPN;AACF;AAQI;EACE,oBAAA;EACA,UAAA;EACA,YAAA;AANN;AAQI;EACE,YAAA;EACA,6BAAA;AANN;AAQI;EACE,oBAAA;EACA,UAAA;AANN;AAOM;EAHF;IAII,UAAA;EAJN;AACF;;AAOA;EACI;IACI,mBAAA;IACA,eAAA;EAJN;EAKM;IACI,sBAAA;EAHV;EAMC;IACC,UAAA;IACA,kBAAA;EAJF;EAME;IACA,WAAA;EAJF;AACF;AAMA;EACE,aAAA;EACA,UAAA;EACA,8BAAA;AAJF;AAKE;EAJF;IAKI,WAAA;IACA,sBAAA;IACA,mBAAA;EAFF;AACF;AAGE;EACE,UAAA;AADJ;AAEI;EAFF;IAGI,sBAAA;EACJ;AACF;AAAI;EACE,oBAAA;EACA,UAAA;AAEN;AADM;EAHF;IAIE,qBAAA;EAIJ;AACF;AADE;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,gCAAA;EACA,mBAAA;AAGJ;;AAAA;EACI,WAAA;EACA,aAAA;EACA,uBAAA;AAGJ;AAFI;EACE,aAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AAIN;AAHM;EACE,WAAA;EACA,kBAAA;AAKR;;AADA;EACE,qDAAA;AAIF;;AAFA;EACE,kBAAA;EACA,mBAAA;EACA,gBAAA;AAKF;;AAHA;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;AAMF;;AAJA;EACE,aAAA;EACA,eAAA;EACA,8BAAA;EACA,iBAAA;AAOF;;AAAA;EACE,WAAA;AAGF;;AADA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AAIF;;AAFA;EACE,6CAAA;AAKF;;AAFA;EACE,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AAKF;;AAFA;EACE,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;AAKF;;AAFA;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,8BAAA;AAKF;;AAFA;EACE,qBAAA;AAKF;AAJE;EACE,WAAA;AAMJ;AAJE;EALF;IAMI,sBAAA;EAOF;AACF;;AAJA;EACE;IACE,eAAA;EAOF;AACF;AAJA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;EACA,2BAAA;AAMF;;AAHA;EACE,OAAA;EACA,WAAA;AAMF","sourcesContent":[".contract-container {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    font-family: \"Barlow\", sans-serif;\n    @media (max-width: 1024px) {\n      width: 100%;\n      display: flex;\n      flex-direction: column;\n      padding: 0rem;\n      margin-top: 95px;\n    }\n  \n    .header {\n      width: 100%;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n      margin: 45px 0px;\n      // padding-left: 2rem;\n      @media (max-width: 1024px) {\n  \n      }\n      h6 {\n        margin: 0px;\n        width: 80%;\n        font-size: 32px;\n        padding-left: 2rem;\n        @media (max-width: 1024px) {\n          font-size: 18px;\n          text-align: center;\n        }\n      }\n      h5 {\n        font-size: 24px;\n        margin-top: 10px;\n        margin-bottom: 0px;\n        color: #706f6f;\n        padding-left: 2rem;\n        @media (max-width: 1024px) {\n          font-size: 16px;\n          text-align: center;\n        }\n      }\n     \n      h6 {\n        margin: 0rem;\n      }\n    }\n  }\n@media (min-width: 1025px) {\n    .header {\n      flex-direction: column !important;\n      justify-content: center !important;\n      align-items: start !important;\n    }\n  }\n\n\n  .form-fields{\n    background-color: #FBFBFB; \n    display: flex;\n    justify-content: start; \n    align-items: center;\n    min-height: 32vh;\n    flex-direction: column; \n    @media(max-width:1024px) {\n        background-color: #FBFBFB;\n    }\n\n    .fields{\n        padding-top: 32px !important;\n        width: 80%;\n    }\n}\n.form-group-row {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    column-gap: 3rem;\n\n   \n    .mat-mdc-form-field {\n        // width: 45%;\n        @media(max-width:1024px){\n          width: 100%;\n        }\n    }\n\n    .first-input {\n        width: 100%;\n    }\n\n    .bank-form-field {\n        width: 30%;\n    }\n\n    p {\n        margin-top: 0px;\n        font-size: 1.1rem;\n    }\n    @media(max-width:1024px){\n      flex-direction: column;\n    }\n}\n\n.form-group {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    column-gap: 3rem;\n\n    .mat-mdc-form-field {\n        // width: 30%;\n    }\n\n    .first-input {\n        width: 100%;\n    }\n\n    .date-input {\n        width: 30%;\n    }\n\n    .bank-form-field {\n        width: 30%;\n    }\n\n    p {\n        margin-top: 0px;\n        font-size: 1.1rem;\n    }\n}\n::ng-deep.mat-mdc-text-field-wrapper{\n  background: white;\n}\n\n.date-select-modal-filter {\n    width: 45%;\n    display: flex;\n    border: 1px solid rgb(189, 188, 188);\n    border-radius: 5px;\n    align-items: center;\n    justify-content: center;\n    height:70px;\n    background:white;\n    @media(max-width:1024px){\n        width: 100%;\n        margin-bottom: 24px;\n    }\n    .mat-mdc-form-field {\n      margin-bottom: -1rem;\n      width: 60%;\n      height: 50px;\n    }\n    .mat-mdc-form-field:nth-of-type(2){\n      height: 50px;    \n      margin-right: 10px !important;\n    }\n    .select-year {\n      margin-bottom: -1rem;\n      width: 40%;\n      @media(max-width:1024px){\n        width: 35%;\n      }\n    }\n  }\n@media(max-width:1240px) {\n    .capexGroup{\n        margin-bottom: 16px; \n        flex-wrap: wrap;\n        .onlyFieldset{\n            width: 100% !important;\n        }   \n    }\n   .form-group .date-select-modal-filter{\n    width: 46%;\n    margin-bottom: 8px; \n   }\n    .form-group .mat-mdc-form-field {\n    width: 100%;\n}\n}\n.section-periodo{\n  display: flex;\n  width: 45%;\n  justify-content: space-between;\n  @media(max-width:1024px) {\n    width: 100%;\n    flex-direction: column;\n    align-items: center;\n  }\n  .date-select-modal-filter{\n    width: 35%;\n    @media(max-width:1024px) {\n      width: 100% !important;\n    }\n    .select-year {\n      margin-bottom: -1rem;\n      width: 75%;\n      @media(max-width:1024px) {\n      width: 35% !important;\n      }\n    }\n  }\n  .periodo{\n    display: flex;\n    flex-direction: row;\n    padding-bottom: 10px;\n    border-bottom: 1px solid #efefef;\n    align-items: center;\n  }\n}\n.button-save{\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    button{\n      display: flex;\n      justify-content: center;\n      color: #AE0F0A;\n      font-size: 16px;\n      width: 25%;\n      min-width: 160px;\n      align-items: end;\n      font-weight: 700;\n      img{\n        width: 20px;\n        padding-right: 8px;\n      }\n    }\n}\n::ng-deep .mat-mdc-icon-button {\n  --mat-mdc-button-persistent-ripple-color: transparent;\n}\n.table-default{\n  padding-left: 2rem;\n  padding-right: 2rem;\n  margin-top: 24px;\n}\n.buttons{\n  display: flex;\n  justify-content: center;\n  margin-top: 24px;\n  margin-bottom:  24px;\n}\n.row{\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  margin: 16px 16px;\n}\n\n// .col-md-3{\n//   width: 22%;\n//   margin: 0 8px;\n// }\n.w-100{\n  width: 100%;\n}\n.info-icon-suffix {\n  width: 14px;\n  height: 14px;\n  margin-right: 10px;\n  cursor: pointer;\n}\n::ng-deep .mat-primary .mat-pseudo-checkbox-checked.mat-pseudo-checkbox-full, .mat-primary .mat-pseudo-checkbox-indeterminate.mat-pseudo-checkbox-full {\n  background-color: rgb(174, 15, 10) !important;\n}\n\n.group {\n  border: 1px solid #ccc;\n  padding: 16px;\n  margin-bottom: 16px;\n  border-radius: 8px;\n}\n\n.group legend {\n  font-size: 1em;\n  font-weight: bold;\n  margin-bottom: 8px;\n  text-align: center;\n  color: rgb(102, 102, 102);\n}\n\n.form-group-row-fieldset {\n  width: 100%;\n  display: flex;\n  align-items: flex-start;\n  column-gap: 3rem;\n  justify-content: space-between;\n}\n\n.onlyFieldset {\n  width: 50% !important;\n  fieldset {\n    width: 100%;\n  }\n  @media (max-width: 1024px) {\n    width: 100% !important;\n  }\n}\n\n@media (max-width: 1321px) {\n  .form-group-row-fieldset {\n    flex-wrap: wrap;\n  }\n}\n\n.prazo-analise-fields {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n.prazo-dias-field-sm {\n  flex: 1;\n  width: 100%;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
